import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import classes from './UserList.module.css';
import { FaUser, FaSortAmountDown, FaPhoneAlt, FaIdBadge, FaInfoCircle, FaEye } from 'react-icons/fa';
import { useTranslation } from "react-i18next";

const UserList = (props) => {
  const { t } = useTranslation();
  const [filteredTableByName, setFilteredTableByName] = useState([]);
  const searchTerm = props.searchPara;
  const userDetails = props.userData;
  const [sortOrder, setSortOrder] = useState('asc');

  useEffect(() => {
    let filteredUserByName = userDetails;

    if (searchTerm && searchTerm.trim() !== "") {
      filteredUserByName = userDetails.filter((user) => {
        const fullName = `${user?.firstName} ${user?.middleName} ${user?.lastName}`;
        const userName = user?.userName || "";
        return fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          userName.toLowerCase().includes(searchTerm.toLowerCase());
      });
    }

    setFilteredTableByName(filteredUserByName);
  }, [userDetails, searchTerm]);

  const toggleSortOrder = () => {
    setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
  };

  const sortedTable = useMemo(() => {
    return [...filteredTableByName].sort((a, b) => {
      return sortOrder === 'asc' ? a.userId - b.userId : b.userId - a.userId;
    });
  }, [filteredTableByName, sortOrder]);

  return (
    <div className={classes.tableContainer}>
      <Table responsive hover className={classes.customTable}>
        <thead>
          <tr>
            <th onClick={toggleSortOrder} style={{ cursor: 'pointer', width: '120px' }}>
              {t("User-Id")} <FaSortAmountDown className="ms-2 opacity-50" />
            </th>
            <th className="text-start ps-4">
              <FaUser className="me-2" /> {t("Name")}
            </th>
            <th>{t("User Name")}</th>
            <th>{t("Role")}</th>
            <th>
              <FaPhoneAlt className="me-2" /> {t("Mobile")}
            </th>
            <th style={{ width: '120px' }}>{t("Action")}</th>
          </tr>
        </thead>
        <tbody>
          {sortedTable.length === 0 && (
            <tr>
              <td colSpan="6" className="py-5 text-center text-muted">
                <FaInfoCircle className="fa-2x mb-2 d-block opacity-50 mx-auto" />
                {t("No user records found.")}
              </td>
            </tr>
          )}
          {sortedTable.map((user) => (
            <tr key={`${user?.userId}`}>
              <td>
                <span className="badge rounded-pill bg-light text-dark border">{user?.userId}</span>
              </td>
              <td className="text-start ps-4 fw-500">
                {`${user?.firstName || ""} ${user?.middleName ? user.middleName + " " : ""}${user?.lastName || ""}`}
              </td>
              <td>{user?.userName}</td>
              <td style={{ fontSize: '0.8rem' }}>
                <span className={classes.roleBadge}>{user?.role}</span>
              </td>
              <td>{user?.mobile || "-"}</td>
              <td>
                <Link to={`${user?.mobile}`} className="btn-outline-premium btn btn-sm px-3" title={t("Detail")}>
                  <FaEye />
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default UserList;
